import { Injectable } from "@angular/core";
import { ManagementOrdersPresenter } from "../presenter/management.presenter";

import { HttpErrorResponse } from "@angular/common/http";
import { InstallationService } from '../../../../services/orders/installation.service';
import { ServworkService } from '../../../../services/orders/servwork.service';
import { TankService } from '../../../../services/orders/tank.service';
import { combineLatest, Observable } from "rxjs";
import { map } from 'rxjs/operators';
import { InstallationModel } from '../../../../models/orders/installation.model';
import { TankModel } from '../../../../models/orders/tank.model';
import { PdfMakeWrapper } from "pdfmake-wrapper";
import { SendPdfEmailService } from '../../../../services/orders/send-pdf-email.service';

@Injectable({providedIn:'root'})
export class ManagementOrdersInteractor {

private _presenter: ManagementOrdersPresenter;

constructor(
  private installationService: InstallationService,
  private servworkService: ServworkService,
  private tankService: TankService,
  private sendPdfEmailService: SendPdfEmailService,
) { }

setPresenter(presenter: ManagementOrdersPresenter):void{
  this._presenter = presenter;
}

async getOrders(page: number, limit: number, startDate?: Date, endDate?: Date, query?: string, status?: string): Promise<any[]> {
  const obs1$ = this.installationService.getAllOrders(page, limit, startDate, endDate, query, status).pipe(map((res) => res ?? []));
  return new Promise((resolve, reject) => {
     obs1$.subscribe((res) => !!res && resolve(res), err => resolve([]) );
  });
}

exportOrdersExcel(startDate?: Date, endDate?: Date, query?: string, status?: string): Observable<Blob> {
  return this.installationService.exportOrdersExcel(startDate, endDate, query, status);
}

editInstallation(model: InstallationModel): void {
  this.installationService.update(model, model._id)
                      .subscribe(
                          resp => this._presenter.getResponse(resp),
                          (err: HttpErrorResponse) => this._presenter.isRequestComplete(false, err)
                        );
}
editServWork(model: TankModel): void {
  this.servworkService.update(model, model._id)
                      .subscribe(
                          resp => this._presenter.getResponse(resp),
                          (err: HttpErrorResponse) => this._presenter.isRequestComplete(false, err)
                        );
}
editTank(model: TankModel): void {
  this.tankService.update(model, model._id)
                      .subscribe(
                          resp => this._presenter.getResponse(resp),
                          (err: HttpErrorResponse) => this._presenter.isRequestComplete(false, err)
                        );
}
deleteInstallation(id: string): void {
  this.installationService.delete(id)
                      .subscribe(
                          resp => this._presenter.getResponse(resp),
                          (err: HttpErrorResponse) => this._presenter.isRequestComplete(false, err)
                        );
}
deleteTank(id: string): void {
   this.tankService.delete(id)
                      .subscribe(
                          resp => this._presenter.getResponse(resp),
                          (err: HttpErrorResponse) => this._presenter.isRequestComplete(false, err)
                        );
}
deleteServWork(id: string): void {
  this.servworkService.delete(id)
                      .subscribe(
                          resp => this._presenter.getResponse(resp),
                          (err: HttpErrorResponse) => this._presenter.isRequestComplete(false, err)
                        );
}
sendPdfEmail(pdf: PdfMakeWrapper, emailTemplate: string, fileName: string, images: File[]): Promise<boolean> {
   return this.sendPdfEmailService.sendPdfEmail(pdf, emailTemplate, fileName, images);
}
}
